/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Error_Rate_LimitedInputs */



/**
* | output |
* | --- |
* | "Too many attempts. Wait a few minutes and try again." |
*
* @param {License_Error_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_error_rate_limited = /** @type {((inputs?: License_Error_Rate_LimitedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Error_Rate_LimitedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trop de tentatives. Patientez quelques minutes et réessayez.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu viele Versuche. Warten Sie einige Minuten und versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Troppi tentativi. Attendi qualche minuto e riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком много попыток. Подождите несколько минут.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Demasiados intentos. Espera unos minutos y vuelve a intentarlo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("尝试次数过多。请稍候几分钟再试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("試行回数が多すぎます。数分待ってから再試行してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बहुत अधिक प्रयास। कुछ मिनट रुककर फिर से कोशिश करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Demasiadas tentativas. Aguarde alguns minutos e tente novamente.")
	return /** @type {LocalizedString} */ ("Too many attempts. Wait a few minutes and try again.")
});